import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UpdateAdmissionInquiryMutation = graphql.persisted(
  "UpdateAdmissionInquiry",
  graphql(`mutation UpdateAdmissionInquiry($input: UpdateAdmissionInquiryInput!) {
    updateAdmissionInquiry(input: $input) {
      admissionInquiry { id state adminNotes }
      userErrors { message path }
    }
  }`)
);

export { UpdateAdmissionInquiryMutation };
export function useUpdateAdmissionInquiry() {
  return useMutation(UpdateAdmissionInquiryMutation);
}
